// extracted by mini-css-extract-plugin
module.exports = {"page-content-container":"Author_page-content-container__1NgVQ","pageContentContainer":"Author_page-content-container__1NgVQ"};